import React, { useContext, useEffect, useState, useCallback, memo } from 'react'
import { CButton, CCol, CCollapse, CRow, CSpinner } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilUserPlus, cilCaretRight, cilFile } from '@coreui/icons'
import PDFView from 'src/views/tender-view/components/PDFView'
import { GlobalVariablesContext } from 'src/contexts/globalVariableContext'
import { AuthContext } from 'src/contexts/authContext'
import AddNewSupplierContactModal from './AddNewSupplierContactModal'
import MultiSelector from './MultiSelector'

const AccordionItem = ({
  t,
  tenderStatus,
  data,
  tenderChapter,
  fetchTenderSubChapters,
  hasAccordionItemsVisible
}) => {
  const { allSuppliers, allSuppliersWithContactsOptions, suppliersLoaded } =
    useContext(GlobalVariablesContext)
  const authContext = useContext(AuthContext)
  const [allSuppliersOptions, setAllSuppliersOptions] = useState([])
  const [visible, setVisible] = useState(false)
  const [pdfModalVisible, setPdfModalVisible] = useState(false)
  const [dataForPDF, setDataForPDF] = useState()
  const [addSupplierContactModalVisible, setAddSupplierContactModalVisible] = useState(false)
  const [suppliers, setSuppliers] = useState([])
  const [hgcSuppliersData, setHgcSuppliersData] = useState([
    { label: !authContext.userInfo || !authContext.systemSettings ? t('HGCSelected').replace("HGC", "") : (!authContext.systemSettings.replaceWordingPerTenderOffice || authContext.role === 'devis_admin' ? t('HGCSelected') : t('HGCSelected').replace("HGC", authContext.userInfo.departmentsNames[0])), code: 'HGC' },
  ])

  const createAllSuppliers = useCallback(() => {
    const suppliers = allSuppliers
      .filter(item => item.active === "active")
      .map(item => ({
        value: item.id,
        label: item.companyName,
      })).sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
    setAllSuppliersOptions(suppliers)

  }, [allSuppliers])

  useEffect(() => {
    createAllSuppliers()
  }, [createAllSuppliers])

  const createHgCSuppliers = useCallback((data) => {
    if (!data || !Array.isArray(data)) {
      setHgcSuppliersData([])
      return
    }

    const hgcSelected = data.map((item) => {
      const options = item?.contacts?.map((contact) => ({
        value: contact.id,
        label:
          contact.firstName && contact.lastName
            ? `${contact.firstName} ${contact.lastName} (${item.companyName})`
            : `${contact.email} (${item.companyName})`,
        selected: contact.isSelected,
        code: 'hgcSelected',
      })) || []

      return {
        label: item.companyName,
        code: 'hgcSelected',
        options,
      }
    }).sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))

    setHgcSuppliersData(hgcSelected)
  }, [])

  useEffect(() => {
    createHgCSuppliers(data?.suppliers)
  }, [data])

  useEffect(() => {
    if (allSuppliersWithContactsOptions.length > 0) {
      const filteredSuppliers = allSuppliersWithContactsOptions
        .filter((supplier) =>
          !hgcSuppliersData.some((hgcProposedSupplier) => hgcProposedSupplier.label === supplier.label)
        )
        .sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }))
      const allSuppliersData = [{ label: t('AllSuppliers'), code: 'allSuppliers' }, ...filteredSuppliers]

      const concatedArray = [...hgcSuppliersData, ...allSuppliersData]

      setSuppliers(
        concatedArray.map((supplier) => {
          if (supplier.options?.length === 0) {
            delete supplier.options
          }
          return supplier
        })
      )
    }
  }, [allSuppliersWithContactsOptions, hgcSuppliersData])

  return (
    <>
      <div className='accordion-item'>
        <div className='accordion-header'>
          <CRow className='justify-content-between align-items-center'>
            <CCol>
              <CRow className='align-items-center'>
                {data.elements && data.elements.length >= 1 ? (
                  <CCol className='col-sm-auto' onClick={() => setVisible(!visible)}>
                    <CIcon
                      icon={cilCaretRight}
                      className={
                        data.elements && (hasAccordionItemsVisible || visible)
                          ? 'rotate'
                          : ''
                      }
                    />
                  </CCol>
                ) : (
                  <CCol className='noIcon'></CCol>
                )}
                {data.isR === true ? (
                  <CCol className='col-md-auto'>{'R'}</CCol>
                ) : (
                  <CCol className='noR'></CCol>
                )}
                <CCol className='col-md-2'>
                  <p>{data.npkNumber}</p>
                </CCol>
                <CCol className='col-md-8'>{data.content && data.content?.toLowerCase() !== 'none' ? <p>{data.content}</p> : <p>{
                  t('TenderView.NoContentForElement')
                    .split('\n')
                    .map((line, index) => (
                      <p key={`${index}_p`}>
                        <i style={{ color: '#a80017' }} key={index}>
                          {line}
                        </i>
                      </p>
                    ))
                }
                </p>}</CCol>
              </CRow>
            </CCol>
            <CCol className='col-md-6'>
              <CRow className='align-items-center'>
                <CCol className='d-flex align-items-center'>
                  {suppliersLoaded ? (
                    <>
                      <MultiSelector
                        tenderStatus={tenderStatus}
                        t={t}
                        id={data.id}
                        suppliers={suppliers}
                      />
                      <div className='add-supplier-contact-modal--trigger ms-4'>
                        <CIcon
                          icon={cilUserPlus}
                          title={t('SupplierContactsOverview.button.AddSupplier')}
                          onClick={() => setAddSupplierContactModalVisible(true)}
                        />
                      </div>
                    </>
                  ) : (
                    <CSpinner color='primary' variant='grow' id={`${data.id}_loader`} />
                  )}
                </CCol>
                <CCol className='col-md-auto d-flex justify-content-end'>
                  <CButton
                    className='d-flex flex-column align-items-center'
                    color='link'
                    onClick={() => {
                      setDataForPDF(data)
                      setPdfModalVisible(true)
                    }}
                  >
                    <CIcon icon={cilFile} size='xl' title='View file' />
                    <span className='ms-2'>
                      {t('Page')} {data.startsOnPage}
                    </span>
                  </CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </div>
      {data.elements && (
        <CCollapse
          visible={data?.elements && (hasAccordionItemsVisible || visible)}
          className='accordion-body pe-0'
        >
          {data.elements
            .sort((a, b) => (a.npkNumber > b.npkNumber ? 1 : -1))
            .map((element) => (
              <CRow className='align-items-center' key={`ne-${element.id}`}>
                <CCol className='empty-cell px-0'></CCol>
                {element.isR === true ? (
                  <CCol className='col-md-auto'>{'R'}</CCol>
                ) : (
                  <CCol className='noR'></CCol>
                )}
                <CCol className='col-md-1'>{element.npkNumber}</CCol>
                <CCol className='col-md-4'>{element.content}</CCol>
                <CCol className='col-md-4'>
                  {element.quantities?.map((item) => (
                    <React.Fragment key={item.id}>
                      {item.quantity && (
                        <>
                          {t('Quantity')}: {item.quantity}
                          <br />
                        </>
                      )}
                      {item.unit && (
                        <>
                          {t('Unit')}: {item.unit}
                          <br />
                        </>
                      )}
                      {item.reference && (
                        <>
                          {t('Reference')}: {item.reference}
                          <br />
                        </>
                      )}
                    </React.Fragment>
                  ))}
                </CCol>
                <CCol className='d-flex justify-content-end'>
                  <CButton
                    className='d-flex flex-column align-items-center'
                    color='link'
                    onClick={() => {
                      setDataForPDF(element)
                      setPdfModalVisible(true)
                    }}
                  >
                    <CIcon icon={cilFile} size='xl' title='View file' />
                    <span className='ms-2'>
                      {t('Page')} {element.startsOnPage}
                    </span>
                  </CButton>
                </CCol>
              </CRow>
            ))}
        </CCollapse>
      )}
      {pdfModalVisible && (
        <PDFView
          t={t}
          data={dataForPDF}
          pdfModalVisible={pdfModalVisible}
          setPdfModalVisible={setPdfModalVisible}
        />
      )}
      <AddNewSupplierContactModal
        t={t}
        id={data.id}
        allSuppliersOptions={allSuppliersOptions}
        addSupplierContactModalVisible={addSupplierContactModalVisible}
        setAddSupplierContactModalVisible={setAddSupplierContactModalVisible}
        fetchTenderSubChapters={fetchTenderSubChapters}
        tenderChapter={tenderChapter}
      />
    </>
  )
}

export default memo(AccordionItem)
